/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AwsDatabaseDestination } from '../models/AwsDatabaseDestination';
import { AwsDynamoDBDestination } from '../models/AwsDynamoDBDestination';
import { EksNamespaceRestoreDestination } from '../models/EksNamespaceRestoreDestination';
import { ObjectStorageDestination } from '../models/ObjectStorageDestination';
import { VirtualMachineRestoreDestination } from '../models/VirtualMachineRestoreDestination';

export class DestinationRestoreTypeAttributes {
  'objectStorage'?: ObjectStorageDestination;
  'azureVm'?: VirtualMachineRestoreDestination | null;
  'dynamoDbTable'?: AwsDynamoDBDestination;
  'eksNamespace'?: EksNamespaceRestoreDestination | null;
  'rdsInstance'?: AwsDatabaseDestination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "objectStorage",
      "baseName": "objectStorage",
      "type": "ObjectStorageDestination",
      "format": ""
    },
    {
      "name": "azureVm",
      "baseName": "azureVm",
      "type": "VirtualMachineRestoreDestination",
      "format": ""
    },
    {
      "name": "dynamoDbTable",
      "baseName": "dynamoDbTable",
      "type": "AwsDynamoDBDestination",
      "format": ""
    },
    {
      "name": "eksNamespace",
      "baseName": "eksNamespace",
      "type": "EksNamespaceRestoreDestination",
      "format": ""
    },
    {
      "name": "rdsInstance",
      "baseName": "rdsInstance",
      "type": "AwsDatabaseDestination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return DestinationRestoreTypeAttributes.attributeTypeMap;
  }

  public constructor() {
  }
}

